export const baseurl = process.env.REACT_APP_BASE_URL;

//////local/////

let url = `${baseurl}/api/v1`;

const ApiConfig = {
  connectWallet: `${url}/user/connectWallet`,
};
export default ApiConfig;
